import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { Student } from '@/types';

interface AttendanceTrendsProps {
  students: Student[];
}

export const AttendanceTrends: React.FC<AttendanceTrendsProps> = () => {
  const trendData = [
    { month: 'Aug', attendance: 96 },
    { month: 'Sep', attendance: 94 },
    { month: 'Oct', attendance: 92 },
    { month: 'Nov', attendance: 91 },
    { month: 'Dec', attendance: 89 }
  ];

  return (
    <Paper sx={{ p: 3, height: '400px' }}>
      <Typography variant="h6" gutterBottom>
        Attendance Trends
      </Typography>

      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={trendData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis domain={[85, 100]} />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="attendance"
            name="Attendance Rate (%)"
            stroke="#8884d8"
            strokeWidth={2}
            dot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
};